export default "__VITE_ASSET__356a6d51__"